
import { PersonLinesFill, DoorOpen, FileText, DateIcon } from "../assets/icons";
import CardChido from "../components/CardChido";
import CardContenedor from "../components/CardContenedor";
import { useEmpleadoStore } from "../stores/useEmpleadoStore";

export default function PanelEmpleados() {

    const objLogueado = useEmpleadoStore(state => state.objLogueado)

    if (objLogueado.permitido !== "empleado") {
        window.location = "/"
        return (<></>)
    }

    const salir = () => {
        if ( !window.confirm('¿Estas seguro de querer cerrar sesión?') ) return

        localStorage.removeItem('user_empleado')
        window.location.href = '/'
    }

    const items = [
        {
            boton: 'Administrar',
            icon: <PersonLinesFill />,
            titulo: 'Administra tus datos personales',
            enlace: '/registro'
        },
        {
            boton: 'Generar solicitud',
            icon: <DoorOpen />,
            titulo: 'Formato para autorización de salida',
            enlace: '/autorizacion_salida'
        },
        {
            boton: 'Generar solicitud',
            icon: <FileText />,
            titulo: 'Oficio de comisión',
            enlace: '/comision'
        },
        {
            boton: 'Solicitar',
            icon: <DateIcon />,
            titulo: 'Solicitar vacaciones',
            enlace: '/solicitar-vacaciones'
        },
    ]

    return (
        <CardContenedor>


            <div className="d-flex justify-content-evenly">
                <h5 className="text-center">Bienvenido {objLogueado.nombre} {objLogueado.apellido}</h5>
                <button className="btn btn-link" onClick={ salir }>Salir</button>
            </div>

            <div className="d-flex justify-content-center flex-wrap">
            {/* <div className="d-grid gap-3 d-lg-block d-xl-block d-xxl-block col-lg-3 col-xl-2 col-xxl-1"> */}

                {items.map(e => (
                    <CardChido
                        icon={ e.icon }
                        key={ e.titulo }
                        boton={ e.boton }
                        titulo={ e.titulo }
                        enlace={ e.enlace }
                    />
                ))}
            </div>
        </CardContenedor>
    )
}
